import { TIME } from "@repo/constants";
import { Config } from "@mobile/config/env";
import { createHttpClient } from "@repo/share-log-api-client";
import { toastService } from "@mobile/features/toast/toast-service";

const BASE_HTTP_CLIENT_TIMEOUT = TIME.SECOND * 10;

const baseHttpClient = createHttpClient({
  baseURL: Config.API_URL,
  timeout: BASE_HTTP_CLIENT_TIMEOUT,
  withCredentials: true,
  onValidationError: () => {
    toastService.error("처리중 에러가 발생했어요.");
  },
});

const minioHttpClient = createHttpClient({
  timeout: BASE_HTTP_CLIENT_TIMEOUT,
  withCredentials: true,
});

export { baseHttpClient, minioHttpClient };
